import fflip from "fflip";

import criteria, { CriteriaType } from "./criteria";

// Add and remove from this type as features are added/removed
// eg: type FeatureType = "a" | "b" | "c"
export type FeatureType =
    | "enableAuthorBio"
    | "enableBlens"
    | "enableBoaRecirc"
    | "enableCustomizableTicker"
    | "enableForYou"
    | "enableInlineRecirc"
    | "enablePlug"
    | "enableSwagger"
    | "enableTransporter"
    | "enableMostRead"
    | "enableReduxDevTools"
    | "enableVerticalVideo"
    | "enableTheWeekend";

type Criteria = {
    [K in CriteriaType]?: boolean;
};

interface FeatureObject {
    id: FeatureType;
    criteria: Criteria | Criteria[];
}

const features: FeatureObject[] = [
    {
        id: "enableAuthorBio",
        criteria: { "env:production": true },
    },
    {
        id: "enableBlens",
        criteria: { "env:production": true },
    },
    {
        id: "enableBoaRecirc",
        criteria: { "env:production": true },
    },
    {
        id: "enableCustomizableTicker",
        criteria: { "env:production": true },
    },
    {
        id: "enableForYou",
        criteria: { "env:production": true },
    },
    {
        id: "enableInlineRecirc",
        criteria: { "env:production": true },
    },
    {
        id: "enablePlug",
        criteria: { "env:production": true },
    },
    {
        id: "enableSwagger",
        criteria: { "env:nonProduction": true },
    },
    {
        id: "enableTransporter",
        criteria: [{ "env:all": true }],
    },
    {
        id: "enableMostRead",
        criteria: { "env:production": true },
    },
    {
        id: "enableReduxDevTools",
        criteria: { "env:nonProduction": true },
    },
    {
        id: "enableVerticalVideo",
        criteria: { "env:all": true },
    },
    {
        id: "enableTheWeekend",
        criteria: [
            { "env:green": true },
            { "env:orange": true },
            { "env:production": true },
        ],
    },
];

fflip.config({
    criteria,
    features,
});

const isEnabled = (feature: FeatureType): boolean =>
    fflip.isFeatureEnabledForUser(feature, {});

export default isEnabled;
